import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PainterKalkbay() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');

  const painter = {
    id: "painters-kalk-bay",
    name: "Painters Kalk Bay",
    location: "Kalk Bay, Cape Town",
    rating: 4.9,
    reviews: 174,
    specialties: ["Coastal Properties", "Heritage Homes", "Artistic Finishes", "Marine-Grade Protection"],
    image: "https://public.readdy.ai/ai/img_res/75caac906bfcc13aaf745464a95a5572.jpg",
    verified: true,
    yearsExperience: 16,
    website: "https://painterskalkbay.co.za",
    email: "info@painterskalkbay.co.za",
    phone: "+27 21 555 0140",
    description: "Professional painting services in Kalk Bay and surrounding False Bay areas. We specialize in coastal properties and heritage homes with expertise in marine-grade finishes and artistic restoration work.",
    services: [
      "Interior House Painting",
      "Exterior House Painting", 
      "Coastal Property Painting",
      "Heritage Home Restoration",
      "Artistic & Decorative Finishes",
      "Waterproofing Services",
      "Damp Proofing Solutions",
      "Color Consultation & Design"
    ],
    serviceAreas: ["Kalk Bay", "St James", "Fish Hoek", "Muizenberg", "Clovelly", "Glencairn", "False Bay"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Beautiful%20interior%20living%20room%20painted%20by%20professional%20painters%20in%20Kalk%20Bay%20Cape%20Town%2C%20charming%20coastal%20cottage%20with%20fresh%20white%20walls%20and%20harbor%20views%2C%20quality%20paint%20finish%2C%20False%20Bay%20scenery%20visible%20through%20windows%2C%20bright%20natural%20lighting%2C%20clean%20professional%20painting%20work%20with%20artistic%20decor%20and%20vintage%20furniture&width=400&height=300&seq=kalkbay-gallery-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20house%20painting%20project%20in%20Kalk%20Bay%20Cape%20Town%20South%20Africa%2C%20colorful%20coastal%20cottage%20with%20fresh%20paint%20overlooking%20False%20Bay%20harbor%2C%20professional%20painters%20working%20on%20scaffolding%2C%20quality%20exterior%20finish%2C%20picturesque%20fishing%20village%20setting%20with%20mountain%20views%2C%20well-maintained%20heritage%20property%20with%20beautiful%20landscaping&width=400&height=300&seq=kalkbay-gallery-2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Heritage%20cottage%20painting%20project%20in%20Kalk%20Bay%20False%20Bay%2C%20professional%20painters%20working%20on%20historic%20property%20exterior%2C%20quality%20residential%20paint%20finish%2C%20traditional%20Cape%20architecture%20with%20harbor%20views%2C%20organized%20work%20site%20with%20painting%20equipment%20and%20materials%2C%20artistic%20village%20atmosphere&width=400&height=300&seq=kalkbay-gallery-3&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Kitchen%20interior%20painting%20in%20Kalk%20Bay%20coastal%20cottage%20Cape%20Town%2C%20fresh%20painted%20walls%20in%20charming%20kitchen%2C%20quality%20paint%20finish%20with%20coastal%20color%20scheme%2C%20bright%20clean%20space%20with%20harbor%20views%2C%20professional%20painting%20work%20with%20vintage%20fixtures%20and%20artistic%20touches&width=400&height=300&seq=kalkbay-gallery-4&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Bedroom%20interior%20painting%20in%20Kalk%20Bay%20beachfront%20cottage%2C%20fresh%20painted%20walls%20in%20cozy%20bedroom%2C%20traditional%20coastal%20design%20with%20ocean%20views%2C%20quality%20paint%20finish%2C%20bright%20airy%20space%2C%20professional%20painting%20work%20with%20artistic%20decor%20and%20natural%20lighting&width=400&height=300&seq=kalkbay-gallery-5&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20coastal%20cottage%20painting%20in%20Kalk%20Bay%20Cape%20Town%2C%20professional%20painters%20applying%20marine-grade%20paint%20to%20heritage%20property%2C%20False%20Bay%20harbor%20backdrop%20with%20fishing%20boats%2C%20quality%20exterior%20finish%20with%20weather%20protection%2C%20organized%20professional%20work%20site%20with%20safety%20equipment%20and%20artistic%20village%20setting&width=400&height=300&seq=kalkbay-gallery-6&orientation=landscape"
    ],
    testimonials: [
      {
        name: "Emma Richardson",
        rating: 5,
        comment: "Outstanding work on our Kalk Bay cottage! The team understood the unique character of our heritage home and delivered a beautiful finish that respects the property's history while providing excellent coastal protection."
      },
      {
        name: "James van der Merwe", 
        rating: 5,
        comment: "Professional service from start to finish. They completed our Kalk Bay home painting on schedule and the quality exceeded our expectations. The marine-grade finishes are holding up perfectly against the salt air."
      },
      {
        name: "Sophie Daniels",
        rating: 5,
        comment: "Exceptional attention to detail and very experienced with coastal and heritage painting. Our cottage looks stunning and we've received countless compliments from neighbors and visitors to the village."
      }
    ]
  };

  useEffect(() => {
    document.title = "Painters Kalk Bay | Professional Coastal & Heritage Painting Services Cape Town | False Bay Painters";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Painters Kalk Bay offers professional painting services for coastal properties and heritage homes in Kalk Bay, Cape Town. Specializing in artistic finishes, marine-grade protection, and False Bay properties. Expert coastal painting contractors.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Painters Kalk Bay, house painters Kalk Bay, coastal painting contractors Cape Town, False Bay painting services, heritage home painting, artistic finishes');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-900 to-black text-white py-32 min-h-[70vh] flex items-center">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20stunning%20coastal%20heritage%20cottage%20in%20Kalk%20Bay%20Cape%20Town%20South%20Africa%2C%20spectacular%20False%20Bay%20harbor%20views%20with%20colorful%20fishing%20boats%20and%20mountains%2C%20painters%20in%20clean%20uniforms%20applying%20paint%20with%20brushes%20and%20rollers%2C%20traditional%20Cape%20architecture%20with%20artistic%20village%20character%2C%20bright%20sunny%20day%2C%20pristine%20work%20environment%20with%20professional%20equipment%20and%20charming%20coastal%20setting&width=1200&height=600&seq=kalkbay-painters-hero-bg&orientation=landscape)` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>
        
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl">
            <div className="inline-block bg-lime-400 text-black px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <i className="ri-shield-check-line mr-2"></i>
              VERIFIED PROFESSIONAL PAINTER
            </div>
            <h1 className="text-5xl lg:text-6xl font-bold leading-tight mb-6">
              Painters Kalk Bay
            </h1>
            <p className="text-2xl text-gray-300 mb-4">
              Expert Coastal & Heritage Painting Services for Artistic Properties
            </p>
            <p className="text-lg text-gray-400 mb-8 leading-relaxed">
              Kalk Bay's most trusted painting contractors specializing in coastal properties, heritage homes, and artistic finishes. With over 16 years of experience serving the False Bay coastline, we deliver exceptional quality and durability using marine-grade materials designed to withstand the harsh coastal environment while preserving the unique character of this historic village.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Main Content Area */}
            <div className="lg:col-span-2">
              {/* Navigation Tabs */}
              <nav className="flex space-x-8">
                {[
                  { id: 'overview', label: 'Overview' },
                  { id: 'services', label: 'Services' },
                  { id: 'gallery', label: 'Gallery' },
                  { id: 'reviews', label: 'Reviews' },
                  { id: 'contact', label: 'Contact' }
                ].map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer ${
                      activeTab === tab.id
                        ? 'border-lime-500 text-lime-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </nav>

              {/* Tab Content */}
              <div className="bg-white rounded-xl shadow-lg p-8">
                {activeTab === 'overview' && (
                  <div className="space-y-8">
                    <div>
                      <h2 className="text-3xl font-bold text-gray-900 mb-6">About Painters Kalk Bay</h2>
                      <div className="prose prose-lg max-w-none text-gray-700 space-y-4">
                        <p className="leading-relaxed">
                          Welcome to Painters Kalk Bay, the False Bay area's premier painting contractor for coastal residential properties and heritage homes. For over 16 years, we have been the trusted choice for homeowners throughout Kalk Bay, St James, Muizenberg, Fish Hoek, and the surrounding False Bay coastline who demand superior craftsmanship, artistic sensitivity, and lasting protection for their unique properties in this historic fishing village.
                        </p>
                        <p className="leading-relaxed">
                          Our reputation has been built on a solid foundation of exceptional quality workmanship, meticulous attention to architectural detail, and an unwavering commitment to customer satisfaction. We understand that living in Kalk Bay's coastal environment presents unique challenges for property maintenance, and we have developed specialized expertise in protecting and beautifying homes exposed to salt spray, strong winds, intense UV radiation, and moisture from the ocean, while respecting the artistic and historical character that makes this village so special.
                        </p>
                        <p className="leading-relaxed">
                          What truly distinguishes Painters Kalk Bay from other painting contractors is our deep understanding of the specific environmental conditions that affect properties along the False Bay coastline, combined with our appreciation for the unique architectural heritage and artistic character of this historic fishing village. The combination of salt-laden sea breezes, high humidity levels, strong south-easterly winds, and intense summer sun requires specialized knowledge, premium marine-grade materials, and proven application techniques. Our team has spent years perfecting our methods to ensure that every project we complete not only looks beautiful but also provides maximum protection and longevity while preserving the distinctive charm of Kalk Bay properties.
                        </p>
                        <p className="leading-relaxed">
                          We take immense pride in our comprehensive, detail-oriented approach to every painting project. From the moment you contact us for an initial consultation through to the final walk-through inspection, we maintain the highest professional standards at every stage. Our process begins with a thorough assessment of your property's condition, taking into account factors such as existing paint condition, substrate type, exposure to elements, architectural significance, and any specific concerns you may have. We then provide detailed recommendations and a transparent, itemized quote with no hidden costs or surprises.
                        </p>
                        <p className="leading-relaxed">
                          Our team of skilled painters are not simply workers applying paint to surfaces; they are experienced craftsmen who take genuine pride in their work and understand the importance of delivering flawless results while respecting the unique character of heritage and coastal properties. Each team member has been carefully selected for their skills, reliability, artistic sensitivity, and commitment to excellence. We invest heavily in ongoing training to ensure our team stays current with the latest techniques, products, and industry best practices, including specialized training in heritage restoration and coastal protection methods.
                        </p>
                        <p className="leading-relaxed">
                          Over the years, we have built an impressive portfolio of completed projects throughout the False Bay area, with particular expertise in Kalk Bay's distinctive cottages and heritage homes. From charming fishing village cottages and family homes to luxury coastal properties and historic buildings, we have successfully completed hundreds of projects of varying sizes and complexity. Each project receives the same level of dedication, professionalism, and attention to detail, regardless of its scope. We treat every home as if it were our own, ensuring that the final result exceeds your expectations while preserving the property's unique character.
                        </p>
                        <p className="leading-relaxed">
                          At Painters Kalk Bay, we believe in building long-term relationships with our clients based on trust, transparency, and consistently excellent results. Many of our customers have been with us for years, returning for maintenance work, renovations, and new projects. They recommend us to their friends, family, and neighbors because they know they can rely on us to deliver superior quality, honest advice, fair pricing, and respect for the architectural heritage of their properties every single time. This loyalty and trust is something we never take for granted, and it drives us to maintain our high standards on every project.
                        </p>
                        <p className="leading-relaxed">
                          Our commitment to excellence extends far beyond the quality of our painting work. We understand that having contractors working in and around your home requires a high level of trust and professionalism. That's why we maintain clean, organized work sites, protect your furniture and belongings, respect your property and privacy, and work efficiently to minimize disruption to your daily routine. We communicate clearly and regularly throughout the project, keeping you informed of progress and addressing any questions or concerns promptly.
                        </p>
                        <p className="leading-relaxed">
                          We use only premium, environmentally responsible paints and materials from leading manufacturers such as Plascon, Dulux, and specialized marine coating suppliers. These products are specifically formulated to provide superior adhesion, durability, and resistance to the harsh coastal conditions found along the False Bay coastline. By investing in the best materials available, we ensure that your paint job not only looks stunning on completion day but continues to look great and provide protection for many years to come, while maintaining the authentic character of your Kalk Bay property.
                        </p>
                      </div>
                    </div>

                    <div className="border-t pt-8">
                      <h3 className="text-2xl font-bold text-gray-900 mb-6">Why Choose Painters Kalk Bay?</h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-award-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">16+ Years Experience</h4>
                            <p className="text-gray-600 text-sm">Over a decade and a half of proven excellence in coastal and heritage property painting throughout the False Bay area.</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-shield-check-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">Fully Insured & Certified</h4>
                            <p className="text-gray-600 text-sm">Comprehensive liability insurance and professional certifications for your complete peace of mind and protection.</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-star-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">Heritage Expertise</h4>
                            <p className="text-gray-600 text-sm">Specialized knowledge in heritage home restoration and preservation of architectural character unique to Kalk Bay.</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-customer-service-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">Outstanding Customer Service</h4>
                            <p className="text-gray-600 text-sm">Clear communication, respect for your property, and an unwavering commitment to exceeding your expectations.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="border-t pt-8">
                      <h3 className="text-2xl font-bold text-gray-900 mb-6">Our Service Areas</h3>
                      <p className="text-gray-700 mb-4 leading-relaxed">
                        Painters Kalk Bay proudly serves the entire False Bay coastline and surrounding areas, including:
                      </p>
                      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                        {['Kalk Bay', 'St James', 'Fish Hoek', 'Muizenberg', 'Clovelly', 'Glencairn', "Simon's Town", 'Sunnydale', 'Capri Village'].map((area) => (
                          <div key={area} className="flex items-center space-x-2 text-gray-700">
                            <i className="ri-map-pin-line text-lime-600"></i>
                            <span>{area}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === 'services' && (
                  <div className="space-y-8">
                    <div>
                      <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Comprehensive Painting Services</h2>
                      <p className="text-gray-700 mb-8 leading-relaxed">
                        At Painters Kalk Bay, we offer a complete range of professional painting services specifically designed for coastal and heritage properties. Our expertise encompasses every aspect of residential painting, from initial consultation and color selection through to meticulous surface preparation, expert application, and thorough final inspection.
                      </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-home-4-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Interior Painting Excellence</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Transform your living spaces with our premium interior painting services. We specialize in creating beautiful, durable finishes that enhance your home's aesthetic appeal while respecting its architectural character. Our meticulous surface preparation and expert application techniques ensure flawless results in every room.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Living rooms, bedrooms, and family areas</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Kitchens and bathrooms with moisture-resistant coatings</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Ceilings, cornices, and architectural features</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Doors, window frames, and trim work</span>
                          </li>
                        </ul>
                      </div>

                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-building-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Coastal Exterior Painting</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Protect and beautify your property's exterior with our specialized coastal painting services. We use premium marine-grade paints and advanced application techniques specifically designed to withstand salt spray, UV radiation, wind, and moisture. Our comprehensive approach includes thorough surface preparation and protective coatings.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Exterior walls with marine-grade protective coatings</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Windows, doors, and exterior trim</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Decks, patios, and outdoor entertainment areas</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Fascias, soffits, and gutter systems</span>
                          </li>
                        </ul>
                      </div>

                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-ancient-gate-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Heritage Home Restoration</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Preserve the unique character of your heritage property with our specialized restoration services. We have extensive experience working with historic buildings and understand the importance of maintaining architectural integrity while providing modern protection and durability.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Period-appropriate color consultation and matching</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Traditional painting techniques and finishes</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Architectural detail preservation and enhancement</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Historic building compliance and documentation</span>
                          </li>
                        </ul>
                      </div>

                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-paint-brush-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Artistic & Decorative Finishes</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Enhance your property with our range of specialty coatings and decorative finishes. From UV-resistant clear coats to textured finishes and custom color matching, we have the expertise and experience to create unique, stunning results that reflect the artistic character of Kalk Bay.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>UV-resistant protective clear coatings</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Textured and decorative wall finishes</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Wood staining, sealing, and varnishing</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Custom color matching and artistic consultation</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === 'gallery' && (
                  <div>
                    <h2 className="text-3xl font-bold text-gray-900 mb-8">Project Gallery</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                      {painter.gallery.map((image, index) => (
                        <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                          <img 
                            src={image} 
                            alt={`${painter.name} project ${index + 1}`}
                            className="w-full h-64 object-cover object-top"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {activeTab === 'reviews' && (
                  <div>
                    <h2 className="text-3xl font-bold text-gray-900 mb-8">Customer Reviews</h2>
                    <div className="space-y-6">
                      {painter.testimonials.map((testimonial, index) => (
                        <div key={index} className="bg-white border border-gray-200 rounded-lg p-6">
                          <div className="flex items-center mb-4">
                            <div className="flex items-center">
                              {[...Array(5)].map((_, i) => (
                                <i key={i} className={`ri-star-fill ${i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                              ))}
                            </div>
                            <span className="ml-3 font-semibold text-gray-900">{testimonial.name}</span>
                          </div>
                          <p className="text-gray-700">{testimonial.comment}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {activeTab === 'contact' && (
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    <div>
                      <h2 className="text-3xl font-bold text-gray-900 mb-6">Contact Information</h2>
                      <div className="space-y-6">
                        <div className="flex items-center">
                          <i className="ri-mail-line text-2xl text-lime-500 mr-4"></i>
                          <div>
                            <h3 className="font-semibold text-gray-900">Email</h3>
                            <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                              {painter.email}
                            </a>
                          </div>
                        </div>
                        
                        <div className="flex items-center">
                          <i className="ri-global-line text-2xl text-lime-500 mr-4"></i>
                          <div>
                            <h3 className="font-semibold text-gray-900">Website</h3>
                            <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                              {painter.website}
                            </a>
                          </div>
                        </div>
                        
                        <div className="flex items-start">
                          <i className="ri-map-pin-line text-2xl text-lime-500 mr-4 mt-1"></i>
                          <div>
                            <h3 className="font-semibold text-gray-900">Service Area</h3>
                            <p className="text-gray-700">{painter.location} and surrounding areas</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-6">Get a Quote</h3>
                      <button 
                        onClick={() => navigate('/quote')}
                        className="w-full bg-lime-400 text-black py-4 rounded-lg font-semibold hover:bg-lime-500 transition-colors text-lg whitespace-nowrap cursor-pointer"
                      >
                        Request Free Quote
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
            
            <div>
              <div className="bg-gray-50 p-6 rounded-lg sticky top-6">
                <div className="mb-6">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20charming%20coastal%20cottage%20in%20Kalk%20Bay%20Cape%20Town%2C%20False%20Bay%20harbor%20with%20colorful%20fishing%20boats%2C%20painters%20in%20uniform%20with%20quality%20equipment%2C%20traditional%20Cape%20architecture%20with%20artistic%20character%2C%20bright%20natural%20lighting&width=400&height=300&seq=kalkbay-sidebar-image&orientation=landscape"
                    alt="Professional painters Kalk Bay coastal cottage painting services Cape Town False Bay heritage homes"
                    className="w-full h-48 object-cover object-top rounded-lg"
                  />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Quick Contact</h3>
                <div className="space-y-4">
                  <div className="flex items-center">
                    <i className="ri-mail-line mr-3 text-lime-500"></i>
                    <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                      {painter.email}
                    </a>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-global-line mr-3 text-lime-500"></i>
                    <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                      Visit Website
                    </a>
                  </div>
                </div>
                
                <button 
                  onClick={() => navigate('/quote')}
                  className="w-full mt-6 bg-lime-400 text-black py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Get Free Quote
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
